export const LATINICA = {
  alert: {
    alert: 'lat'
  },
  general: {
    kengur: 'Kengur',
    kengurFull: 'Kengur bez granica - Društvo matematičara Srbije',
    none: 'Nema',
    unknown: 'Nepoznato',
    all: 'Sve'
  },
  meni: {
    homePage: 'Početna Strana',
    listofStudents: 'Lista Učenika',
    listofUser: 'Lista Korisnika',
    listofSchool: 'Lista Škola',
    displayResults: 'Prikaz rezultata',
    user: 'Korisnici',
    students: 'Učenici',
    school: 'Škole',
    complaints: 'Žalbe',
    location: 'Lokacije',
    category: 'Kategorije',
    reviewPapers: 'Pregled radova',
    statistics: 'Statistika',
    resultsStatistics: 'Statistika rezultata',
    languageStatistics: 'Statistika na osnovu  jezika',
    genderStatistics: 'Statistika u odnosu na pol',
    classandCategoryStatistics: 'Statistika za razrede',
    addNewSchool: 'Dodaj novu školu',
    addNewStudent: 'Prijavi učenika',
    printList: 'Štampaj listu',
    profile: 'Profil',
    menu: 'Meni',
    manage: 'Upravljaj',
    data: 'Podaci',
    hello: 'Zdravo ',
    schools: 'Škole',
    listofSchools: 'Lista škola',
    signStudent: 'Prijavi učenika',
    allStudents: 'Svi učenici',
    results: 'Rezultati',
    complaintsForStudent: 'Žalbe',
    reviewComplaints: 'Pregled žalbi',
    newComplaints: 'Podnesi žalbu',
    settings: 'Podešavanja',
    changePassword: 'Promena lozinke',
    logout: 'Odjavi se',
    users: 'Korisnici',
    schoolWorkReview: 'Pregled radova',
    importstudents: 'Uvoz iz Excela',
    diplomas: 'Diplome'
  },
  tabs: {
    all_complaints: 'Sve Žalbe',
    unread_by_admin: 'Admin Nije Pročitao',
    unread_by_school: 'Škola Nije Pročitala',
    admin_responses: 'Odgovor Admina',
    unanswered_complaints: 'Nerešene Žalbe',
    finished_complaints: 'Rešene žalbe',
    users: 'Korisnici',
    allUsers: 'Svi korisnici',
    teachers: 'Nastavnici',
    admins: 'Administratori',
    schools: 'Škole',
    dms: 'DMS',
    DMS: 'DMS'
  },
  status: {
    read: 'Pročitano',
    unread: 'Nije Pročitano'
  },
  pagination: {
    rows_per_page: 'Redova po strani:',
    of: 'od',
    more_than: 'više od',
    moreThan: 'više od',
    rowsPerPage: 'Redova po stranici',
    noRowsLabel: 'Nema rezultata',
    footerRowSelected: 'Selektovan red'
  },
  dialog: {
    read: 'Pročitano',
    unread: 'Nepočitano',
    edit: 'Izmeni',
    delete: 'Obriši',
    submitButton: 'Dodaj novu',
    editPayment: 'Izmeni plaćanje',
    addPayment: 'Dodaj plaćanje',
    payment: 'Evidencija plaćanja',
    successfullyDeleted: 'Uspešno obrisano',
    schoolLabel: 'Škola',
    studentNameLabel: 'Ime i prezime učenika',
    genderLabel: 'Pol',
    categoryLabel: 'Kategorija',
    addStudentTitle: 'Dodaj novog učenika',
    classGradeLabel: 'Razred',
    professorLabel: 'Profesor',
    languageLabel: 'Jezik',
    cancelButton: 'Otkaži',
    schoolName: 'Ime Škole',
    male: 'Muški',
    female: 'Ženski',
    serbian: 'Srpski (Ćirilica)',
    croatian: 'Hrvatski',
    hungarian: 'Mađarski',
    latin: 'Srpski (Latinica)',
    romanian: 'Rumunski',
    nameRequired: 'Ime i prezime su obavezni.',
    genderRequired: 'Pol je obavezan.',
    categoryRequired: 'Kategorija je obavezna.',
    gradeError: 'Razred mora biti broj između 1 i 12.',
    professorRequired: 'Profesor je obavezan.',
    languageRequired: 'Jezik je obavezan.',
    schoolRequired: 'Obavezno izaberite školu takmičenja.',
    selectSchool: 'Izaberite školu',
    confirmDeleteTitle: 'Potvrdi brisanje',
    confirmDeleteMessage:
      'Da li ste sigurni da želite da obrišete ovaj zapis? Ova akcija je trajna i ne može se poništiti.',
    confirmButton: 'Potvrdi',
    confirmDelete:
      'Da li ste sigurni da želite da uradite brisanje? Ova radnja nije moguće opozvati.',
    yes: 'Da',
    no: 'Ne',
    pending: 'Na Čekanju',
    resolved: 'Rešeno',
    successTitle: 'Uspešno',
    successMessage:
      'Vaša žalba je uspešno podneta. Hvala što ste nas obavestili. Profesori će pregledati vašu žalbu i preduzeti odgovarajuće korake. Bićete obavešteni o statusu žalbe u najkraćem mogućem roku.',
    viewComplaintsButton: 'Pogledajte sve žalbe',
    okButton: 'OK',
    resetPasswordTitle: 'Resetuj lozinku za {{user}}',
    resetPasswordInstruction:
      'Unesite novu lozinku ili generišite nasumičnu za korisnika.',
    newPassword: 'Nova lozinka',
    generatePassword: 'Generiši lozinku',
    generatedPasswordInfo:
      'Možete izmeniti generisanu lozinku ako je potrebno.',
    cancel: 'Otkaži',
    confirm: 'Potvrdi',
    passwordResetSuccess: 'Lozinka je uspešno resetovana.',
    passwordResetError:
      'Došlo je do greške prilikom resetovanja lozinke. Molimo pokušajte ponovo.',
    dateLabel: 'Datum',
    classLabel: 'Razred',
    complaintMessageLabel: 'Poruka žalbe',
    submitComplaint: 'Podnesi Žalbu',
    complaintSubmissionDetails: 'Detalji o podnošenju žalbe',
    ormTitle: 'Forma za podnošenje Žalbe',
    editComplaint: 'Izmeni Žalbu',
    loadStudentsError: 'Greška pri učitavanju učenika',
    saveError: 'Greška pri čuvanju',
    saveButton: 'Sačuvaj',
    schoolRead: 'Škola pročitala',
    schoolUnread: 'Škola nije pročitala',
    formTitle: 'Forma za podnošenje žalbe',
    notInComplaintMode:
      'Trenutno nije moguće podneti žalbu jer mod žalbi nije aktivan.',
    success: {
      complaintSubmitted: 'Žalba je uspešno podneta.'
    },
    error: {
      missingFields: 'Nedostaju obavezna polja.',
      fetchingStudents: 'Greška pri preuzimanju učenika.',
      submittingComplaint: 'Greška pri podnošenju žalbe.',
      invalidEmail: 'Uneli ste neispravnu email adresu.',
      studentRegistrationNotAllowed:
        'Prijavljivanje učenika nije dozvoljeno u trenutnoj fazi.'
    },
    close: 'Zatvori',
    editSchool: 'Izmeni školu',
    name: 'Ime',
    role: 'Rola',
    remark: 'Napomena',
    saveChanges: 'Sačuvaj promene',
    addUser: 'Dodaj korisnika',
    username: 'Korisničko ime',
    password: 'Lozinka',
    school: 'Škola',
    notes: 'Napomena',
    sendEmail: 'Pošalji mejl korisniku',
    save: 'Sačuvaj',
    enterEmail:
      'Unesite email adresu koju ste prijavili prilikom registracije.',
    email: 'Email',
    send: 'Pošalji',
    diplomaFieldsNote: 'ℹ️ Napomena vezana za diplome o poljima škole',
    diplomaSchoolNote:
      'Izaberite školu takmičenja iz spiska — ovo polje je obavezno. Polje „Matična škola" popunite samo ako učenik dolazi iz škole koja nije u sistemu (npr. učenik dolazi iz jedne škole, a takmiči se preko druge škole). U tom slučaju unesite naziv i mesto u formatu: „Naziv škole, Mesto" — npr. „OŠ Jovan Jovanović Zmaj, Novi Sad". Na diplomi će biti prikazana matična škola umesto škole takmičenja.',
    maticnaLabel: 'Matična škola (ako se razlikuje od škole takmičenja)',
    maticnaPlaceholder: 'npr. OŠ Jovan Jovanović Zmaj, Novi Sad',
    maticnaHelperText:
      'Format: „Naziv škole, Mesto" — zarez je važan jer odvaja naziv od mesta na diplomi',
    maticnaFormat: '„Naziv škole, Mesto"',
    maticnaExample: '„OŠ Jovan Jovanović Zmaj, Novi Sad"'
  },
  schoolDiplomasPage: {
    title: 'Diplome',
    subtitle: 'Preuzmite diplome učenika vaše škole',
    yearLabel: 'Godina',
    zlatnaTooltipAvailable: 'Preuzmi Zlatnu zahvalnicu (ZZ)',
    zlatnaTooltipUnavailable: 'Škola nema Zlatnu zahvalnicu',
    downloadZlatnaButton: 'Zlatna zahvalnica (ZZ)',
    zahvalnicaTooltipAvailable: 'Preuzmi Zahvalnicu (Z)',
    zahvalnicaTooltipUnavailable: 'Škola nema Zahvalnicu',
    downloadZahvalnicaButton: 'Zahvalnica (Z)',
    downloadAllDiplomas: 'Preuzmi sve diplome',
    emptyState: 'Nema dostupnih diploma za vašu školu',
    searchPlaceholder: 'Pretraga po imenu',
    downloadTooltip: 'Preuzmi diplomu',
    noSchoolFromAccount: 'Nije moguće utvrditi školu iz naloga.',
    typeLabels: {
      zlatna: 'Zlatna zahvalnica',
      prviRang: 'Diploma prvog ranga',
      finalniRang: 'Diploma finalnog ranga',
      zahvalnica: 'Zahvalnica'
    },
    awardLabels: {
      awardI: 'I nagrada',
      awardII: 'II nagrada',
      awardIII: 'III nagrada',
      awardPohvala: 'Pohvala',
      awardZlatna: 'Zlatna zahvalnica',
      awardZahvalnica: 'Zahvalnica'
    }
  },
  diplomasBySchool: {
    title: 'Diplome po školama',
    subtitle: 'Upravljanje i preuzimanje diploma',
    yearLabel: 'Godina',
    importExcel: 'Uvezi Excel',
    zahvalnice: 'Zahvalnice',
    zlatnaCertificate: 'Zahvalnice',
    allResults: 'Svi rezultati',
    allDiplomas: 'Sve diplome',
    searchPlaceholder: 'Pretraga',
    downloadResults: 'Preuzmi rezultate škole',
    downloadDiplomas: 'Preuzmi diplome',
    diplomasZip: 'Diplome (ZIP)',
    selectZlatnaFileAndTemplate: 'Izaberite Excel fajl i šablon za Zlatnu zahvalnicu.',
    invalidExcelColumns: 'Nema validnih redova. Proverite nazive kolona: ID, Naziv škole, Mesto',
    bulkCreateError: 'Greška pri kreiranju: {{error}}',
    bulkCreateRequestFailed: 'Greška pri slanju zahteva za kreiranje.',
    noSchoolFoundForIds: 'Nijedna škola nije pronađena u bazi po datim ID-jevima.',
    zlatnaGeneratedSuccess: 'Zlatne zahvalnice su uspešno generisane ({{count}}).',
    zahvalnicaGeneratedSuccess: 'Zahvalnice su uspešno generisane ({{count}}).',
    importSuccess: 'Excel je uspešno uvezen.',
    diplomasGeneratedSuccess: 'Diplome su uspešno generisane.',
    diplomasGenerationFailed: 'Generisanje diploma nije uspelo.',
    importFailed: 'Uvoz nije uspeo. Pokušajte ponovo.',
    failedDownloadAllDiplomas: 'Neuspešno preuzimanje svih diploma.',
    failedDownloadAllResults: 'Neuspešno preuzimanje svih rezultata.',
    failedDownloadResults: 'Neuspešno preuzimanje rezultata.',
    failedDownloadDiplomaZip: 'Neuspešno preuzimanje ZIP fajla sa diplomama.',
    invalidZipArchive: 'Preuzeti fajl nije ispravan ZIP arhiva.',
    templateTypes: 'Tipovi',
    noMatchingStudentsFound: 'Nisu pronađeni odgovarajući učenici na serveru.',
    errorProcessingExcel: 'Greška prilikom obrade Excel fajla.',
    excelReadError: 'Greška pri čitanju Excel fajla.',
    noSchoolIdFound: 'Nije pronađen ID škole.',
    noResultsFoundForSchool: 'Nema rezultata za ovu školu.',
    noDiplomaZipAvailable: 'Nema dostupnog ZIP fajla sa diplomama.',
    schoolId: 'Škola {{schoolId}}',
    typeLabels: {
      zlatna: 'Zlatna zahvalnica',
      prviRang: 'Diploma prvog ranga',
      finalniRang: 'Diploma finalnog ranga',
      zahvalnica: 'Zahvalnica'
    }
  },
  diplomaVerifyPage: {
    title: 'Verifikacija diplome',
    subtitle: 'Unesite ID sertifikata sa diplome da proverite autentičnost',
    back: 'Nazad',
    certIdLabel: 'ID sertifikata',
    certIdHelper: 'Unesite ID sertifikata',
    certIdPlaceholder: 'npr. SVC63CMK-123',
    checking: 'Proveravanje...',
    verifyButton: 'Proveri diplomu',
    verifiedTitle: 'Diploma je verifikovana ✓',
    verifiedId: 'ID: {{id}}',
    student: 'Učenik',
    class: 'Razred',
    school: 'Škola',
    year: 'Godina',
    diplomaType: 'Tip diplome',
    award: 'Nagrada',
    verifyAnother: 'Proveri drugu diplomu',
    notFoundTitle: 'Diploma nije pronađena',
    notFoundMessage: 'ID sertifikata nije ispravan ili diploma ne postoji.',
    tryAgain: 'Pokušaj ponovo',
    footer: 'Sistem za verifikaciju diploma',
    checkError: 'Greška pri proveri. Pokušajte ponovo.'
  },
  errors: {
    invalidEmail: 'Uneli ste neispravnu email adresu.',
    required: 'Obavezno polje',
    locationMismatch:
      'Poštanski broj i grad se ne poklapaju. Molimo vas da ispravite podatke.',
    saveDataError: 'Greška prilikom čuvanja podataka.',
    schoolNameMismatch:
      'Moguće je dodavati učenike samo za svoju školu. Naziv škole u fajlu se ne poklapa sa nazivom škole koja je ulogovana.',
    schoolNotExistWarning: 'Škola ne postoji u bazi. Biće dodata nova škola.',
    passwordLength: 'Lozinka mora imati najmanje 6 cifara',
    duplicateUserName: 'Korisničko ime već postoji.'
  },
  error: {
    missingFields:
      'Molimo vas da odaberete učenika za kojeg podnosite žalbu i unesete poruku žalbe.',
    fetchingStudents: 'Greška prilikom preuzimanja učenika ili žalbi.',
    complaintAlreadyExists: 'Žalba je već podneta za ovog učenika.',
    submittingComplaint: 'Greška prilikom podnošenja žalbe.'
  },
  success: {
    complaintSubmitted: 'Žalba je uspešno podneta'
  },
  login: {
    reqFields: 'Korisničko ime i lozinka su obavezna polja',
    reqistrationReq: 'Popunite obavezna polja',
    loginError: 'Pogrešna lozinka i/ili korisničko ime',
    registrationError:
      'Niste uneli ispravno zvaničnu e-mail adresu škole. Ukoliko nemate pristup, prijavite problem na kengur@dms.rs',
    generalError:
      'Škola sa unetim korisničkim imenom već postoji. Ukoliko imate problem, obratite se na mejl: kengur@dms.rs.',
    title: 'Kengur bez granica - Društvo matematičara Srbije',
    username: 'Korisničko ime',
    password: 'Lozinka',
    register: 'Registracija',
    forgotPassword: 'Zaboravljena lozinka',
    instructions: 'Uputstvo za prijavu',
    signInButton: 'Prijavi se',
    signIn: 'Prijava',
    registerButton: 'Registruj se',
    noAccount: 'Ukoliko nemate nalog, registrujte se!',
    welcomeBack: 'Dobrodošli nazad!',
    welcomeBackText:
      'Unesite korisničko ime i lozinku kako biste se prijavili!',
    selectCity: 'Izaberite grad',
    selectSchool: 'Izaberite školu',
    schoolName: 'Ime škole',
    schoolStreet: 'Ulica škole',
    schoolTelephone: 'Broj telefona škole',
    teacher: 'Nastavnik',
    schoolEmail: 'Email škole',
    useEmailForRegistration: 'Koristite email za registraciju',
    signUpButton: 'Registruj se',
    registrationSuccess: 'Uspešna registracija',
    loginDataSentToEmail:
      'Lozinka i korisničko ime su vam uspešno poslati na mejl',
    confirm: 'Potvrdi',
    addUser: 'Dodaj korisnika',
    generatePassword: 'Generiši lozinku',
    role: 'Uloga',
    school: 'Škola',
    notes: 'Beleške',
    sendEmail: 'Pošalji mejl korisniku',
    cancel: 'Otkaži',
    save: 'Sačuvaj',
    enterEmail: 'Unesite svoju email adresu:',
    emailRequired: 'Email adresa je obavezna',
    resetEmailSent: 'Email sa instrukcijama za reset lozinke je poslat'
  },
  columns: {
    id: 'ID',
    name: 'Ime',
    studentName: 'Ime i prezime',
    diplomaType: 'Tip diplome',
    award: 'Nagrada',
    diploma: 'Diploma',
    diplomas: 'Diplome',
    results: 'Rezultati',
    maticnaSkola: 'Matična škola',
    type: 'Tip',
    school: 'Škola',
    location: 'Lokacija',
    accountNumber: 'Broj računa',
    paymentDate: 'Datum plaćanja',
    statementNumber: 'Broj izvoda',
    student_num: 'Broj učenika',
    remark: 'Napomena',
    actions: 'Akcije',
    zipCode: 'Poštanski broj',
    zipcode: 'Poštanski broj',
    street: 'Ulica',
    telephone: 'Broj telefona',
    email: 'Email',
    professor: 'Profesor',
    action: 'Akcija',
    gender: 'Pol',
    result: 'Rezultat',
    category: 'Kategorija',
    class: 'Odeljenje',
    language: 'Jezik',
    point_sum: 'Ukupni poeni',
    studentCount: 'Broj učenika',
    school_id: 'ID Škole',
    student_id: 'ID učenika',
    sender_name: 'Ime Pošiljaoca',
    message: 'Poruka',
    status: 'Status',
    school_read: 'Škola Pročitala',
    admin_read: 'Admin Pročitao',
    date: 'Datum',
    schoolName: 'Ime škole',
    cityName: 'Ime grada',
    title: 'Pregled Žalbi',
    student: 'Učenik',
    selectClass: 'Izaberite razred',
    admin_response: 'Odgovor Admina',
    userName: 'Korisničko ime',
    userPass: 'Lozinka',
    isAdmin: 'Administrator',
    userGroup: 'Korisnička grupa',
    sessionID: 'ID sesije',
    lastLog: 'Poslednja prijava',
    userRemark: 'Napomena',
    question: 'Pitanje',
    lastMessageDate: 'Datum poslednje poruke'
  },
  filter: {
    filters: 'Filtri',
    export: 'Izvoz',
    columns: 'Kolone',
    column: 'Kolona',
    density: 'Gustina',
    print: 'Štampaj',
    exportCSV: 'Izvezi CSV',
    hideAll: 'Sakrij Sve',
    showAll: 'Prikaži Sve',
    addFilter: 'Dodaj Filter',
    removeAll: 'Ukloni Sve',
    linkOperator: 'Operator Povezivanja',
    operator: 'Operator',
    value: 'Vrednost',
    valueFilter: 'Vrednost filtera',
    input: 'Unos',
    operatorAnd: 'I',
    contains: 'sadrži',
    operatorOr: 'Ili',
    inputLabelAnd: 'Unos (I)',
    inputLabelOr: 'Unos (Ili)',
    addFilterLabel: 'Dodaj Filter',
    removeFilterLabel: 'Ukloni Filter',
    clearFilters: 'Očisti Filtre',
    nameColumns: 'Naziv kolone',
    searchColumns: 'Pretraži kolone',
    equals: 'jednako',
    startsWith: 'počinje sa',
    endsWith: 'završava se sa',
    isEmpty: 'je prazno',
    isNotEmpty: 'nije prazno',
    isAnyOf: 'je bilo koji od',
    compact: 'Kompaktno',
    standard: 'Standardno',
    comfortable: 'Komforno',
    city: 'Grad',
    school: 'Škola'
  },
  search: {
    placeholder: 'Pretraga...'
  },
  table: {
    noRows: 'Nema podataka za prikaz'
  },
  text: {
    welcomeHomePage: 'Dobro došli na početnu stranu',
    downloadReports: 'Preuzmi izveštaje',
    studentCountMessage: 'Prijavili ste {{count}} učenika',
    welcome: 'Dobrodošli {{name}}',
    date: 'Datum',
    studentCount: 'Broj prijavljenih učenika',
    top5Students: 'Top 5 učenika',
    importantDates: 'Važni datumi',
    polls: 'Ankete',
    vote: 'Glasaj',
    reports: 'Izveštaji',
    downloadReport: 'Preuzmi izveštaj',
    studentResults: 'Rezultati učenika',
    schoolPerformance: 'Performanse škole',
    youAreNotASchoolUser: 'Niste ulogovani kao školski korisnik'
  },
  profile: {
    title: 'Profil',
    username: 'Korisničko Ime',
    name: 'Ime',
    email: 'Email',
    phone: 'Telefon',
    address: 'Adresa',
    city: 'Grad',
    school: 'Škola',
    saveChanges: 'Sačuvaj Promene',
    changePassword: 'Promeni Lozinku',
    currentPassword: 'Trenutna Lozinka',
    newPassword: 'Nova Lozinka',
    confirmNewPassword: 'Potvrdi Novu Lozinku',
    passwordMismatch: 'Lozinke se ne poklapaju',
    passwordChangeSuccess: 'Lozinka je uspešno promenjena',
    passwordChangeError: 'Greška prilikom promene lozinke',
    updateSuccess: 'Profil je uspešno ažuriran',
    updateError: 'Greška prilikom ažuriranja profila',
    cancel: 'Otkaži',
    zipcode: 'Poštanski Broj',
    professor: 'Profesor',
    validationError: 'Ovo polje je obavezno.',
    confirmPassword: 'Potvrdite lozinku'
  },
  validation: {
    futureDateError: 'Datum ne može biti u budućnosti.',
    fixErrors: 'Ispravite greške pre nego što nastavite.'
  },
  results: {
    title: 'Rezultati',
    tabsLabel: 'Izaberite razred',
    allClasses: 'Svi razredi',
    grade: 'Razred {{grade}}',
    gender: 'Pol',
    all: 'Svi',
    male: 'Muški',
    female: 'Ženski',
    language: 'Jezik',
    allLanguages: 'Svi jezici',
    serbian: 'Srpski',
    english: 'Engleski',
    points: 'Poeni',
    name: 'Ime',
    grade1: 'Razred',
    noStudents: 'Nema učenika prijavljenih za ovaj razred',
    noData: 'Nema podataka za prikaz',
    croatian: 'Hrvatski',
    hungarian: 'Mađarski',
    latin: 'Srpski (Latinica)',
    romanian: 'Rumunski',
    studentsTable: 'Tabela učenika',
    accessDenied:
      'Pristup rezultatima trenutno nije moguć jer se takmičenje nalazi u fazi koja to ne omogućava.',
    allSchools: 'Sve škole',
    mySchool: 'Moja škola'
  },
  statistic: {
    title: 'Statistika u odnosu na pol',
    description: 'Pregled statistike u odnosu na pol',
    averageResultTitle: 'Prosečan Rezultat u odnosu na pol',
    studentCountTitle: 'Broj Učenika u odnosu na pol',
    legend: 'Legenda',
    male: 'Muški',
    female: 'Ženski',
    gender: 'Pol',
    value: 'Vrednost',
    noData: 'Nema podataka',
    resultStatistic: 'Statistika Rezultata',
    generalOverview: 'Opšti Pregled',
    grade: 'Razred',
    studentCount: 'Broj Učenika',
    averageScore: 'Prosečan Rezultat',
    lowestScore: 'Najniži Rezultat',
    highestScore: 'Najviši Rezultat',
    totalPoints: 'Ukupno Poena',
    totalCount: 'Ukupan Broj',
    noResultMode: 'Trenutno nije moguće pregledati statistiku rezultata.',
    maxScore: 'Najviši Rezultat',
    avgScore: 'Prosečan Rezultat',
    studentCountByLanguage: 'Broj Učenika na osnovu izabranog jezika',
    languageTableTitle: 'Tabela Broja Učenika na osnovu izabranog jezika',
    language: 'Jezik',
    serbian: 'Srpski - Ćirilica',
    croatian: 'Hrvatski',
    hungarian: 'Mađarski',
    latin: 'Srpski (Latinica)',
    romanian: 'Rumunski',
    pageTitle: 'Statistika na osnovu izabranog jezika',
    languages: {
      С: 'Srpski - Ćirilica',
      Х: 'Hrvatski',
      М: 'Mađarski',
      Л: 'Srpski - Latinica',
      Р: 'Rumunski'
    }
  },
  snackbar: {
    deleteSuccess: 'Učenik je uspešno obrisan!',
    addSuccess: 'Učenik je uspešno dodat!'
  },
  statisticsByLanguage: {
    chartTitle: 'Broj Učenika na osnovu izabranog jezika',
    tableTitle: 'Tabela Broja Učenika na osnovu izabranog jezika',
    language: 'Jezik',
    studentCount: 'Broj Učenika',
    noData: 'Nema podataka'
  },
  alerts: {
    submissionClosed:
      'Prijavljivanje je završeno i trenutno nije moguće dodavati ili menjati učenike.',
    schoolDeleted: 'Škola je uspešno obrisana.',
    schoolSaved: 'Izmene su uspešno sačuvane.',
    studentAdded: 'Učenik je uspešno dodat!',
    studentDeleted: 'Učenik je uspešno obrisan.',
    studentsImported: 'Uspešno uvezeni učenici'
  },
  headers: {
    enrolledStudents: 'Prijavljeni učenici:',
    total: 'Ukupno',
    grade: 'Razred {{grade}}',
    userManagement: 'Upravljanje korisnicima'
  },
  complaints: {
    complaintAlreadyExistsTitle: 'Žalba Već Postoji',
    complaintAlreadyExistsMessage: 'Žalba je već podneta za ovog učenika.',
    viewAllComplaints: 'Prikaži Sve Žalbe',
    noActiveMode:
      'Trenutno nema aktivnog moda za pregled ili podnošenje žalbi.',
    noCreateComplaints:
      'Podnošenje žalbi trenutno nije moguće jer se takmičenje nalazi u fazi koja to ne omogućava.',
    noViewComplaints:
      'Pregledanje žalbi trenutno nije moguće jer se takmičenje nalazi u fazi koja to ne omogućava.',
    noViewStatisticsCondition:
      'Pregled statistike trenutno nije moguć jer se takmičenje nalazi u fazi koja to ne omogućava',
    noComplaintsAllowed: 'Podnošenje žalbi nije omogućeno u trenutnom modu.',
    reviewPending: 'Pregledanje je završeno, možete sada podnositi žalbe.',
    canSubmitAndEdit: 'Možete podnositi, uređivati i pregledati žalbe.',
    reviewOnly:
      'Rok za podnošenje žalbi je istekao. Možete samo pregledati postojeće žalbe.',
    noComplaintsInResultsMode: 'Žalbe nisu dostupne u modu Rezultati.',
    complaintDetails: 'Detalji Žalbe',
    professor: 'Profesor',
    noComplaints: 'Škola još uvek nije podnela nijednu žalbu',
    message: 'Poruka',
    response: 'Odgovor Kengur Administracije',
    noResponse: 'Još uvek nema odgovora',
    date: 'Datum',
    administrator: 'Administrator',
    school: 'Škola',
    mark_as_read: 'Odgovori na žalbu',
    send_response: 'Pošalji odgovor',
    close: 'Zatvori',
    all: 'Sve',
    pending: 'Nepregledane',
    responded: 'Pregledane',
    title: 'Žalbe',
    allComplaints: 'Sve žalbe',
    unansweredComplaints: 'Neodgovorene žalbe',
    finishedComplaints: 'Završene žalbe',
    worksButton: 'Radovi',
    studentInfo: 'Informacije o učeniku',
    acceptComplaint: 'Prihvati žalbu',
    sendResponse: 'Pošalji odgovor',
    markAsRead: 'Obeleži kao pročitano',
    send: 'Pošalji',
    yourMessage: 'Vaša poruka',
    acceptedComplaintMessage:
      'Poštovani, vaša žalba na rad učenika ID:{{studentId}} je uvažena.',
    clickToView: 'Kliknite za pregled žalbe',
    tabsLabel: 'Pregled žalbi'
  },
  activeMode: 'Trenutno aktivana faza:',
  modes: {
    FLAG_ZALBE: 'Žalbe',
    FLAG_REZULTATI_SKOLA_G: 'Pregledanje u toku',
    FLAG_REZULTATI: 'Preliminarni rezultati',
    FLAG_FINALE: 'Konačni rezultati',
    FLAG_SAKRI_KLJUCEVE: 'Sakri Ključeve',
    FLAG_ZABRANA: 'Zabrana prijavljivanja učenika',
    FLAG_AUTOMATSKO_POVEZIVANJE: 'Automatsko povezivanje radova'
  },
  noActiveMode: 'Prijavljivanje u toku',
  adminDashboard: {
    administration: 'Administracija',
    students: 'Učenici',
    schools: 'Škole',
    locations: 'Lokacije',
    competitionModes: 'Faze Takmičenja',
    users: 'Korisnici',
    categories: 'Kategorije',
    complaints: 'Žalbe',
    passwordResetRequests: 'Zahtjevi za Reset Lozinke',
    solutionReports: 'Izveštaji o Rešenjima',
    results: 'Rezultati',
    reports: 'Izveštaji',
    bestResults: 'Najbolji rezultati',
    passwordResets: 'Resetovanje Lozinki',
    solutions: 'Rešenja',
    close: 'Zatvori',
    adminDashboard: 'Kontrolna tabla',
    genderStatistics: 'Statistika u odnosu na pol',
    languageStatistics: 'Statistika na osnovu  jezika',
    resultsStatistics: 'Statistika Rezultata',
    logout: 'Odjavi se',
    title: 'Kontrolna tabla',
    studentsCount: 'Ukupno učenika',
    total_students: 'Ukupno učenika',
    manage_students: 'Upravljaj učenicima',
    schoolsCount: 'Ukupno škola',
    total_schools: 'Ukupno škola',
    manage_schools: 'Upravljaj školama',
    complaintsNoResponse: 'Neodgovorene žalbe',
    manage_complaints: 'Upravljaj žalbama',
    current_competition: 'Trenutni faza takmičenja',
    manage_competition: 'Upravljaj takmičenjem',
    students_by_class: 'Broj učenika po razredima',
    gender_distribution: 'Statistika učenika po polu',
    recent_complaints: 'Poslednje podnete žalbe',
    pending_complaints: 'Neodgovorene žalbe',
    current_mode: 'Trenutna faza',
    mode_name: 'Naziv moda',
    status: 'Status',
    phase_competition: 'Faza takmičenja',
    roles: 'Role',
    homePage: 'Početna stranica',
    review: 'Pregled',
    manageSolutions: 'Upravljanje rešenjima',
    manageFinalSolutions: ' Upravljanje rešenjima',
    reviewSchools: 'Pregled radova ',
    reviewFinalSchools: ' Pregled radova ',
    verifyReviews: 'Provera pregleda',
    verifyFinalReviews: ' Provera pregleda',
    resultsByGrade: 'Rezultati po razredima',
    resultsByFinalGrade: ' Rezultati po razredima',
    other: 'Ostalo',
    profile: 'Profil',
    final_review: 'Pregled Finala',
    diplomaManagement: 'Upravljanje Diplomama',
    diplomaTemplates: 'Šabloni Diploma',
    diplomasBySchool: 'Diplome po Školama',
    diplomaVerification: 'Verifikacija Diplome',
    schoolDiplomaManagement: 'Upravljanje Diplomama',
    schoolDiplomas: 'Diplome',
    schoolDiplomaVerification: 'Verifikacija Diplome'
  },
  roles: {
    title: 'Uloge',
    searchPlaceholder: 'Pretraži uloge...',
    addNew: 'Dodaj novu ulogu',
    editTitle: 'Izmeni ulogu',
    addTitle: 'Dodaj novu ulogu',
    nameLabel: 'Naziv uloge',
    notesLabel: 'Beleške',
    cancel: 'Otkaži',
    save: 'Sačuvaj',
    edit: 'Izmeni',
    delete: 'Obriši',
    admin: 'Administrator',
    nastavnikPMF: 'Nastavnik PMF',
    skola: 'Škola',
    dms: 'DMS',
    DMS: 'DMS'
  },
  adminModovi: {
    title: 'Upravljanje Fazama Takmičenja',
    subtitle: 'Aktiviraj ili deaktiviraj fazu za takmičenja.',
    noDescription: 'Nema opisa dostupnog.',
    saveChanges: 'Sačuvaj promene',
    fetchError: 'Greška pri preuzimanju faza:',
    updateError: 'Neuspešna izmena moda sa ID:',
    saveSuccess: 'Sve promene su uspešno sačuvane.',
    saveError: 'Greška pri čuvanju promena.',
    cleanArchiveButton: 'Arhiviraj i očisti sve',
    cleanDialogTitle:
      'Da li ste sigurni da želite da arhivirate i očistite sve?',
    cleanDialogContent:
      'Svi podaci će biti arhivirani, a tabele će biti ispražnjene. Ova akcija se ne može opozvati.',
    cancel: 'Odustani',
    confirm: 'Potvrdi',
    cleanSuccess: 'Podaci su uspešno arhivirani i očišćeni.',
    cleanError: 'Došlo je do greške prilikom procesa čišćenja.',
    diplomaNote: 'ℹ️ Napomena o diplomama',
    diplomaArchiveNote:
      'Diplome za tekuću godinu biće arhivirane i ostaju vidljive u tabeli po školama.',
    pdfNotDeleted: 'PDF fajlovi se ne brišu sa diska.',
    dataWillBeCleared: 'Učenici, rezultati i ostali podaci biće očišćeni.',
    zahvalnicaWarning: '⚠️ Važno: Ako želite da generišete Zahvalnice (Z) za ovu godinu, učinite to PRE nego pritisnete „Arhiviraj i očisti sve", jer se Zahvalnice generišu na osnovu tabele pregledanja koja će biti ispraznjena ovom akcijom.'
  },
  adminschool: {
    addNew: 'Dodaj novu školu',
    title: 'Adminstracija škola'
  },
  location: {
    zipcode: 'Poštanski broj',
    area: 'Opština',
    name: 'Naziv',
    actions: 'Akcije',
    addLocation: 'Dodaj Lokaciju',
    locationDetails: 'Detalji Lokacije',
    save: 'Sačuvaj',
    locationUpdated: 'Lokacija ažurirana',
    locationAdded: 'Lokacija dodata',
    locationDeleted: 'Lokacija obrisana',
    errorFetchingLocations: 'Greška pri preuzimanju lokacija',
    errorSavingLocation: 'Greška pri čuvanju lokacije',
    errorDeletingLocation: 'Greška pri brisanju lokacije',
    manageLocations: 'Upravljanje Lokacijama'
  },
  categories: {
    title: 'Kategorije',
    searchPlaceholder: 'Pretraga kategorija…',
    addNew: 'Nova Kategorija',
    edit: 'Uredi',
    delete: 'Obriši',
    editTitle: 'Izmeni Kategoriju',
    addTitle: 'Dodaj Novu Kategoriju',
    nameLabel: 'Naziv Kategorije',
    notesLabel: 'Napomena',
    cancel: 'Odustani',
    save: 'Sačuvaj'
  },
  modeDescriptions: {
    FLAG_ZABRANA: 'Završeno prijavljivanje učenika',
    FLAG_ZALBE: 'Dozvoljeno podnošenje žalbi',
    FLAG_SAKRI_KLJUCEVE: 'Sakri Ključeve',
    FLAG_REZULTATI_SKOLA_G: 'Pregledanje u toku',
    FLAG_REZULTATI: 'Preliminarni rezultati',
    FLAG_FINALE: 'Konačni rezultati',
    FLAG_AUTOMATSKO_POVEZIVANJE: 'Automatsko povezivanje radova'
  },
  review: {
    total_connected_works: 'Ukupan broj povezanih radova',
    total_scanned_works: 'Ukupan broj skeniranih radova',
    total_reviewed_works: 'Ukupan broj pregledanih radova',
    scanned_works: 'Broj skeniranih radova',
    totalRegisteredSchools: 'Ukupno prijavljenih škola: {{count}}',
    currentlyScanned: 'Trenutno skenirano: {{count}} škola',
    currentlyScannedFinal: 'Trenutno skenirano: {{count}} razreda',
    searchById: 'Pretraga po ID-u',
    deleteReview: 'Obriši sve radove sa servera',
    grade: 'Razred',
    showAll: 'Prikaži sve',
    clearAll: 'Očisti sve',
    grade_suffix: 'razred',
    notificationTitle: 'Obaveštenje',
    noAccessMessage: 'Nemate dozvolu za pristup ovoj stranici.',
    closeButton: 'Zatvori',
    student_count: 'Broj učenika',
    total_students: 'Ukupan broj učenika',
    reviewed_students: 'Pregledani učenici',
    unreviewed_students: 'Nepregledani učenici',
    competition_overview: 'Pregled takmičenja',
    unconnected_students: 'Nepovezani učenici',
    connected_students: 'Povezani učenici',
    search_students: 'Pretraga učenika',
    class: 'Razred',
    movement: 'Pomeranje',
    filterCompleted: 'Prikaži završene',
    filterInProgress: 'Prikaži u toku',
    filterNotStarted: 'Prikaži nezapočete',
    resetFilter: 'Resetuj filter',
    showFullyConnected: 'Prikaži potpuno povezane',
    connect: 'Poveži',
    disconnect: 'Ponovo poveži',
    previous: 'Prethodna',
    next: 'Sledeća',
    work: 'Rad',
    noUncheckedStudents: 'Nema nepregledanih učenika',
    noCheckedStudents: 'Nema pregledanih učenika',
    no_more_works: 'Nema više radova za povezivanje',
    no_work_for_display: 'Nema radova za prikaz',
    disconnect_confirmation: 'Potvrda odvezivanja',
    disconnect_confirmation_message:
      'Da li ste sigurni da želite da ponovo povežete rad ovog učenika?',
    cancel: 'Otkaži',
    success_connecting: 'Uspešno povezivanje!',
    error_connecting: 'Povezivanje nije uspelo!',
    success_disconnecting: 'Uspešno odvezivanje!',
    error_disconnecting: 'Odvezivanje nije uspelo!',
    error_occurred: 'Došlo je do greške!',
    work_number: '{{current}} od {{total}}',
    id: 'ID',
    school_name: 'Škola',
    scanned_works_count: 'Broj skeniranih radova',
    connected_works_count: 'Povezani radovi',
    action: 'Akcija',
    schools_with_works: 'Škole sa radovima',
    connecting_works: 'Povezivanje radova',
    connect_description: 'Ovde možete povezati radove sa učenicima.',
    'Povezivanje radova': 'Povezivanje radova',
    'Pregledanje u toku': 'Pregledanje u toku',
    'Završeno pregledanje': 'Završeno pregledanje',
    'Provera pregledanja': 'Provera pregledanih radova',
    back: 'Nazad',
    finish: 'Završi',
    finishReview: 'Završi pregledanje',
    reset: 'Resetuj',
    all_steps_complete: 'Svi koraci su završeni.',
    searchStudent: 'Pretraga učenika',
    studentExam: 'Ispit učenika',
    studentInfo: 'Informacije o učeniku',
    editStudentInfo: 'Promeni',
    name: 'Ime',
    school: 'Škola',
    location: 'Mesto',
    professor: 'Profesor',
    status: 'Status',
    working: 'Radim',
    finished: 'Završeno',
    text: 'Pregledali ste sve radove ove škole, možete završiti pregledanje',
    opacity: 'Providnost',
    points: 'Poeni',
    confirmReview: 'Potvrdi pregledanje',
    resetReview: 'Ponovo pregledaj',
    confirmResetTitle: 'Poništi pregled?',
    confirmResetMessage:
      'Da li ste sigurni da želite da poništite sve promene?',
    yes: 'Da',
    reviewResetSuccess: 'Uspešno poništen pregled!',
    reviewError: 'Došlo je do greške prilikom poništavanja pregleda.',
    refreshError: 'Došlo je do greške prilikom osvežavanja liste učenika.',
    tabs: {
      unreviewed: 'Nepregledani',
      reviewed: 'Pregledani'
    },
    review: 'Pregledaj',
    db_points: 'Poeni u bazi',
    currentViewer: 'Pregleda',
    searchStudents: 'Pretraga učenika',
    gender: 'Pol',
    male: 'Muški',
    female: 'Ženski',
    language: 'Jezik',
    croatian: 'Hrvatski',
    serbian: 'Srpski',
    totalPoints: 'Ukupno poena',
    address: 'Adresa',
    changeSchoolData: 'Promeni podatke o školi',
    changeStudentData: 'Promeni podatke o učeniku',
    studentWork: 'Rad učenika',
    number: 'Broj',
    total: 'Ukupno',
    change: 'Izmeni',
    dialogTitle: 'Upozorenje',
    finishedMessage:
      'Škola je već pregledana od strane {{reviewer}}. Ako nastavite, možete prebrisati postojeće rezultate.',
    inProgressMessage:
      'Školu trenutno pregledava {{reviewer}}. Ako nastavite, može doći do preklapanja.',
    unknownStatusMessage: 'Škola ima nepoznat status.',
    proceed: 'Nastavi',
    professor_name: 'Pregledač',
    in_progress: 'U toku',
    completed: 'Završeno',
    not_started: 'Nije započeto',
    schools: 'Po školama',
    grades: 'Po razredima',
    schoolsTitle: 'Pregled po školama',
    gradesTitle: 'Pregled po razredima',
    search: 'Pretraži...',
    review_by_school_title: 'Provera pregledanih radova',
    connect_automatic: 'Poveži automatski',
    automatic_connection_report: 'Izveštaj o automatskom povezivanju',
    connect_manually: 'Ručno povezivanje',
    successfully_connected: 'Uspešno povezano',
    failed_connections: 'Neuspešna povezivanja',
    failed_works: 'Neuspešni radovi',
    file: 'Fajl',
    reason: 'Razlog',
    close: 'Zatvori'
  },
  language: {
    latin: 'Srpski (Latinica)',
    cyrillic: 'Srpski (Ćirilica)',
    hungarian: 'Mađarski'
  },
  loading: {
    title: 'Učitavanje...',
    loading: 'Učitavanje...',
    description: 'Molimo Vas da sačekate dok pripremamo podatke'
  },
  statistics: {
    genderDistribution: 'Statistika učenika po polu',
    studentByClass: 'Učenici po razredima',
    class: 'Razred',
    numberOfStudents: 'Broj učenika',
    date: 'Datum',
    studentCount: 'Broj učenika',
    grade: 'Razred',
    averageScore: 'Prosečan rezultat',
    lowestScore: 'Najniži rezultat',
    highestScore: 'Najviši rezultat',
    totalPoints: 'Ukupno poena',
    noViewStatisticsCondition: 'Trenutno ne možete da vidite statistiku',
    resultsByGrade: 'Statistika rezultata po razredu'
  },
  solutions: {
    save: 'Sačuvaj',
    cancel: 'Otkaži',
    updatedSuccessfully: 'Uspešno ažurirano!',
    taskNumber: 'Broj',
    points: 'Poeni',
    letters: {
      A: 'A',
      B: 'B',
      V: 'V',
      G: 'G',
      D: 'D',
      X: 'X'
    },
    grade: 'Razred',
    solutions: 'Rešenja',
    actions: 'Akcije',
    errorFetchingSolutions: 'Greška prilikom preuzimanja rešenja'
  },
  button: {
    addUser: 'Dodaj korisnika'
  },
  result: {
    title: 'Rezultati po razredima',
    allCategories: 'Sve kategorije',
    exportExcel: 'Eksportuj u Excel',
    exportFiltered: 'Eksportuj filtrirane',
    resultsByGrade: 'Rezultati po razredima',
    generatePDF: 'Generiši PDF',
    gradeTabs: 'Tabovi za razrede',
    name: 'Ime',
    school: 'Škola',
    place: 'Mesto',
    points: 'Poeni',
    final: 'Finale',
    viewWork: 'Pogledaj rad',
    pdfFilename: 'Rezultati_razred_{{grade}}',
    grade: 'razred',
    category: 'Kategorija',
    searchPlaceholder: 'Pretraži učenika...'
  },
  resetPassword: {
    title: 'Resetovanje lozinke',
    newPass: 'Nova lozinka',
    confirm: 'Potvrdi lozinku',
    resetButton: 'Resetuj lozinku',
    passwordMismatch: 'Lozinke se ne poklapaju.',
    successMessage:
      'Uspešno ste resetovali lozinku. Bićete preusmereni na početnu stranu.',
    generalError: 'Došlo je do greške prilikom resetovanja lozinke.',
    loading: 'Učitavam...',
    loadingButton: 'Molimo sačekajte...'
  },
  importStudentsDialog: {
    title: 'Uvoz učenika',
    uploadPrompt: 'Otpremite Excel fajl sa spiskom učenika:',
    schoolInfo: 'Informacije o školi',
    studentsList: 'Spisak učenika',
    schoolNotFound: 'Škola nije pronađena.',
    read: 'Pročitano',
    unread: 'Nije pročitano',
    edit: 'Izmeni',
    delete: 'Obriši',
    successfullyDeleted: 'Uspešno obrisano',
    noStudentsInExcel: 'Ne postoje studenti u Excel fajlu.',
    schoolCanBeChanged:
      'Ako škola iz Excel fajla nije prepoznata, možete izabrati odgovarajuću školu iz liste škola za koju će biti dodati učenici iz Excela.'
  },
  student: {
    name: 'Ime i prezime',
    category: 'Kategorija',
    grade: 'Razred',
    language: 'Jezik',
    gender: 'Pol'
  },
  school: {
    name: 'Naziv škole',
    street: 'Ulica i broj',
    city: 'Mesto',
    zipcode: 'Poštanski broj',
    teacher: 'Odgovorni nastavnik',
    phone: 'Telefon',
    email: 'E-pošta'
  },
  buttons: {
    cancel: 'Otkaži',
    save: 'Sačuvaj',
    chooseFile: 'Izaberi fajl',
    noFileChosen: 'Nijedan fajl nije izabran'
  },
  messages: {
    studentsAdded: 'Učenici su uspešno dodati.',
    canEditSchoolData: 'Možete izmeniti podatke o školi.'
  },
  form: {
    school: 'Škola',
    accountNumber: 'Broj računa',
    paymentDate: 'Datum plaćanja',
    statementNumber: 'Broj izvoda',
    note: 'Napomena',
    location: 'Lokacija'
  },
  filters: {
    location: 'Izaberi lokaciju'
  },
  modals: {
    editPayment: 'Izmena plaćanja',
    addPayment: 'Dodavanje plaćanja'
  },
  links: {
    downloadTemplate: 'Preuzmi šablon za dodavanje učenika'
  },
  diplomaTemplate: {
    pageTitle: 'Šabloni diploma',
    searchPlaceholder: 'Pretraži šablone...',
    addNew: 'Dodaj novi šablon',
    editTitle: 'Izmeni šablon diplome',
    addTitle: 'Dodaj novi šablon diplome',
    noTemplates: 'Nema pronađenih šablona.',
    nameLabel: 'Naziv šablona',
    nameRequired: 'Naziv šablona je obavezan',
    typeRequired: 'Tip diplome je obavezan',
    yearRequired: 'Godina je obavezna',
    imageRequired: 'Slika šablona je obavezna',
    year: 'Godina',
    type: 'Tip',
    typeLabel: 'Tip:',
    yearLabel: 'Godina:',
    uploadImage: 'Otpremi sliku šablona',
    zlatna: 'Zlatna zahvalnica (ZZ)',
    prviRang: 'Diploma prvog ranga',
    finalniRang: 'Diploma finalnog ranga',
    zahvalnica: 'Zahvalnica (Z)'
  },
  importDiploma: {
    title: 'Izaberite šablon diplome',
    fileWarning: '⚠️ Obavezno: fajl mora biti u Excel formatu (.xlsx ili .xls)',
    fileInstruction:
      'Morate izabrati šablon diplome i Excel fajl da biste kreirali diplome. Excel fajl služi samo za identifikaciju učenika — podaci se preuzimaju iz baze.',
    fileTypeError: 'Greška: Fajl mora biti Excel format (.xlsx ili .xls)',
    yearConflictTitle: 'Diplome za {{year}}. godinu ({{type}}) već postoje!',
    yearConflictBody:
      'Trenutno postoji {{count}} generisanih diploma ovog tipa za ovu godinu. Nastavkom uvoza postojeće diplome će biti zamenjene novim.',
    finalRangWarningTitle: '⚠️ Šablon finalnog ranga',
    finalRangWarningBody:
      'Diplome će biti generisane samo za učenike sa I, II i III nagradom. Učenici sa pohvalom neće dobiti diplomu.',
    selectTemplateFirst: '* Prvo izaberite šablon',
    selectFile: 'Izaberi Excel fajl',
    replaceAndImport: 'Zameni i uvezi',
    import: 'Uvezi',
    generating: "Generisanje diploma"
  },
  importZlatna: {
    title: 'Uvoz Zlatne zahvalnice',
    subtitle: 'Izaberite šablon i Excel fajl',
    instruction:
      'Morate izabrati šablon i Excel fajl da biste kreirali zahvalnice. Excel fajl mora imati kolone: ID (školski ID iz baze), Naziv škole i Mesto.',
    onlyZlatnaTitle: '⭐ Samo šabloni tipa „Zlatna zahvalnica"',
    onlyZlatnaNote:
      'Prikazani su isključivo šabloni tipa Zlatna zahvalnica. Svaka škola dobija maksimalno 1 zahvalnicu. Naziv i mesto se preuzimaju direktno iz Excel fajla (ne iz baze).',
    noTemplatesTitle: '⚠️ Nema šablona tipa „Zlatna zahvalnica".',
    addTemplateFirst:
      'Prvo dodajte šablon tog tipa na strani upravljanja šablonima.',
    yearConflictTitle: 'Zlatne zahvalnice za {{year}}. godinu već postoje!',
    yearConflictBody:
      'Trenutno postoji {{count}} generisanih zahvalnica za ovu godinu. Nastavkom uvoza postojeće zahvalnice će biti zamenjene novim.',
    replaceAndGenerate: 'Zameni i generiši',
    generate: 'Generiši zahvalnice',
    generating: "Generisanje zahvalnica"

  },
  importZahvalnica: {
    dialogTitle: 'Zahvalnice',

    zzTabLabel: 'Zlatna zahvalnica',
    zTabLabel: 'Zahvalnica',

    zzSubtitle: 'Za škole odabrane na osnovu Excel fajla',
    zSubtitle: 'Za sve škole sa učenicima koji su učestvovali',

    zzExplanationTitle: 'Zlatna zahvalnica (ZZ) — odabrane škole',
    zzExplanationBody:
      'Zlatna zahvalnica se dodeljuje samo onim školama koje su postigle izuzetan uspeh. ' +
      'Potrebno je učitati Excel fajl sa ID-jevima škola koje treba nagraditi. ' +
      'Naziv i mesto škole se preuzimaju direktno iz Excel fajla.',

    zExplanationTitle: 'Zahvalnica (Z) — sve škole učesnice',
    zExplanationBody:
      'Zahvalnica se automatski generiše za sve škole čiji su učenici učestvovali na takmičenju ' +
      '(tj. škole koje imaju unos u tabeli pregledanja). ' +
      'Nije potreban Excel fajl — podaci o školi se preuzimaju direktno iz baze.',

    zNoSchoolsTitle: 'Nema škola u tabeli pregledanja.',

    generate: 'Generiši zahvalnice',
    replaceAndGenerate: 'Zameni i generiši'
  }
};